import Reveal from "@/components/Reveal";

const rows = [
  { years: "2018", role: "Business development & event marketing", note: "First lessons in what makes people pay attention." },
  { years: "2020–22", role: "Growth, operations & audience development", note: "Building systems, audiences and content engines." },
  { years: "2022–23", role: "B2B content & thought leadership", note: "Turning expertise into narratives buyers remember." },
  { years: "2023–25", role: "Global marketing & partnerships", note: "Content and campaigns across markets." },
  { years: "Today", role: "CtrlB Consulting", note: "Independent, white-glove LinkedIn & personal brand strategy." },
];

export default function Background() {
  return (
    <section id="experience" className="bg-[#09090B] border-t border-[#F3F0E8]/10 scroll-mt-20">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-24 sm:py-32">
        <Reveal>
          <div className="flex flex-wrap items-end justify-between gap-8">
            <div>
              <p className="text-xs uppercase tracking-[0.3em] text-[#CFE9EF]/70">background</p>
              <h2
                data-testid="background-heading"
                className="font-serif-d font-black tracking-tight leading-[1.0] text-4xl sm:text-6xl text-[#F3F0E8] mt-6"
              >
                Experience you can{" "}
                <span className="italic font-semibold text-[#F3F0E8]/45">borrow.</span>
              </h2>
            </div>
            <p className="text-base sm:text-lg text-[#F3F0E8]/55 leading-relaxed max-w-md lg:pb-2">
              I'm independent, not inexperienced. Every engagement draws on my
              8+ years across brand building, growth and audiences.
            </p>
          </div>
        </Reveal>

        <div className="mt-14 border-t border-[#F3F0E8]/10">
          {rows.map((r, i) => (
            <Reveal key={r.years} delay={i * 0.06}>
              <div
                data-testid={`background-row-${i + 1}`}
                className="group grid sm:grid-cols-12 gap-2 sm:gap-6 items-baseline py-6 sm:py-7 border-b border-[#F3F0E8]/10 hover:bg-[#F3F0E8]/[0.03] transition-colors duration-500 px-2 sm:px-4"
              >
                <span className="sm:col-span-2 text-xs tracking-[0.25em] text-[#118C4F]">{r.years}</span>
                <h3 className="sm:col-span-6 font-serif-d font-semibold tracking-tight text-xl sm:text-2xl text-[#F3F0E8]/90 group-hover:text-[#F3F0E8] transition-colors duration-300">
                  {r.role}
                </h3>
                <p className="sm:col-span-4 text-sm text-[#F3F0E8]/45 leading-relaxed sm:text-right">
                  {r.note}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
